"use strict";

var _regeneratorRuntime2 = require("@babel/runtime/regenerator");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = markAllAsSpokenOnStopSpeakActivitySaga;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _effects = require("redux-saga/effects");

var _activities = require("../selectors/activities");

var _stopSpeakingActivity = require("../actions/stopSpeakingActivity");

var _markActivity = _interopRequireDefault(require("../actions/markActivity"));

var _speakingActivity = _interopRequireDefault(require("../definitions/speakingActivity"));

var _marked = /*#__PURE__*/_regeneratorRuntime2.mark(markAllAsSpoken),
    _marked2 = /*#__PURE__*/_regeneratorRuntime2.mark(markAllAsSpokenOnStopSpeakActivitySaga);

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function markAllAsSpoken() {
  var speakingActivities, _iterator, _step, activity;

  return _regenerator["default"].wrap(function markAllAsSpoken$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.select)((0, _activities.of)(_speakingActivity["default"]));

        case 2:
          speakingActivities = _context.sent;
          _iterator = _createForOfIteratorHelper(speakingActivities);
          _context.prev = 4;

          _iterator.s();

        case 6:
          if ((_step = _iterator.n()).done) {
            _context.next = 12;
            break;
          }

          activity = _step.value;
          _context.next = 10;
          return (0, _effects.put)((0, _markActivity["default"])(activity, 'speak', false));

        case 10:
          _context.next = 6;
          break;

        case 12:
          _context.next = 17;
          break;

        case 14:
          _context.prev = 14;
          _context.t0 = _context["catch"](4);

          _iterator.e(_context.t0);

        case 17:
          _context.prev = 17;

          _iterator.f();

          return _context.finish(17);

        case 20:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[4, 14, 17, 20]]);
} // TODO: [P4] We should turn this into a reducer instead


function markAllAsSpokenOnStopSpeakActivitySaga() {
  return _regenerator["default"].wrap(function markAllAsSpokenOnStopSpeakActivitySaga$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.takeEvery)(_stopSpeakingActivity.STOP_SPEAKING_ACTIVITY, markAllAsSpoken);

        case 2:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2);
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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